import React, { useEffect, useState } from "react";
import classNames from "classnames";
import { PaginationItemProps } from "./PropsType";

export default function PaginationItem(props: PaginationItemProps) {
  const {
    className,
    component,
    index,
    prefixCls = "bm-PaginationItem",
  } = props;
  const [data, setData] = useState({
    active: false,
    disabled: false,
  });
  const { active, disabled } = data;
  const styleClass = classNames(
    prefixCls,
    {
      [`${prefixCls}-active`]: !!index && active!,
      [`${prefixCls}-disabled`]: disabled!,
    },
    className
  );

  const handleClick = () => {
    if (props.onClick) {
      props.onClick();
    }
  };

  useEffect(() => {
    setData({
      active: !!props.active,
      disabled: !!props.disabled,
    });
  }, [props.active, props.disabled]);

  return (
    <li className={styleClass} onClick={handleClick}>
      <span className={`${prefixCls}-btn`}>{component}</span>
    </li>
  );
}
